export default function load(url, cb) {
  const xhr = new XMLHttpRequest();

  const async = true;
  xhr.open('GET', url, async);

  xhr.onload = () => {
    const { responseText, status, statusText } = xhr;
    if (status === 200) {
      cb(null, responseText);
    } else {
      cb(new Error(statusText), null);
    }
  };

  xhr.onerror = () => {
    cb(new Error("Transfer error"), null);
  };

  try {
    xhr.send();
  } catch (error) {
    cb(error, null);
  }

  return () => {
    xhr.abort();
  };
}
